import React from 'react'
import CMS from '../../components/cms/CMS'

const BulletinsPage = () => {
    return (
        <CMS>
            
        </CMS>
    )
}

export default BulletinsPage
